import { render, staticRenderFns } from "./LayoutHeader.vue?vue&type=template&id=5c3bc1c6&scoped=true"
import script from "./LayoutHeader.vue?vue&type=script&lang=js"
export * from "./LayoutHeader.vue?vue&type=script&lang=js"
import style0 from "./LayoutHeader.vue?vue&type=style&index=0&id=5c3bc1c6&prod&scoped=true&lang=css"
import style1 from "./LayoutHeader.vue?vue&type=style&index=1&id=5c3bc1c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3bc1c6",
  null
  
)

export default component.exports